export default __webpack_public_path__ + "static/media/logo.331341fd.svg";